import { useContentType, usePageContentId } from '@confluence/page-context';
import {
	ContentType,
	isCanvasContentType,
} from '@confluence/content-types-utils/entry-points/contentTypeConstants.ts';

import { useHasReceivedActiveCommentMarkers } from './activeCommentMarkersReceived.ts';

/**
 * Whether, for the current content type, the comments panel moves threads whose inline
 * comment no longer exists in the content into the "Deleted content" view.
 */
export const useIsNewDanglingCommentExperienceEnabled = (): boolean => {
	const [contentType] = useContentType();
	const [contentId] = usePageContentId();
	const hasReceivedActiveCommentMarkers = useHasReceivedActiveCommentMarkers(contentId);

	if (contentType === ContentType.SLIDE) {
		// Slides supply orderedActiveAnnotationIdList after their iframe loads, so the list
		// is empty until then. Returning true while the list is empty would show every
		// thread under "Deleted content", so this hook returns false until the list has
		// arrived.
		return hasReceivedActiveCommentMarkers;
	}

	// Databases and the other canvas content types never populate
	// orderedActiveAnnotationIdList.
	return contentType !== ContentType.DATABASE && !isCanvasContentType(contentType);
};
